import {checkAndExecute} from 'root/api/helpers';

export default function BookingAnalyticsAPI(api) {

  api.bookingAnalytics = {

    getAccountBookingAnalyticsStatus: accountId => checkAndExecute(
      () => accountId,
      () => api.server.get(`rfps/hotel/booking-analytics/${accountId}/status`)),

    getReport: (accountId, rfpId) => checkAndExecute(
      () => accountId && rfpId,
      () => api.server.get(`rfps/hotel/booking-analytics/${accountId}/${rfpId}/report`)),

    deleteReport: (accountId) => checkAndExecute(
      () => accountId,
      () => api.server.delete(`rfps/hotel/booking-analytics/${accountId}`)),

    getRfpAndDestinations: (accountId, rfpId) => checkAndExecute(
      () => accountId && rfpId,
      () => api.server.get(`rfps/hotel/booking-analytics/${accountId}/rfps/${rfpId}`)),

    getAccountsAndRfps: accountId => checkAndExecute(
      () => accountId,
      () => api.server.get(`rfps/hotel/booking-analytics/${accountId}/rfps`)),

    getBookings: (accountId, rfpId, bookingId) => checkAndExecute(
      () => accountId && rfpId && bookingId,
      () => api.server.get(`rfps/hotel/booking-analytics/${accountId}/rfps/${rfpId}/bookings/${bookingId}`)),

    createBids: (accountId, rfpId, hotelsPerDestination) => checkAndExecute(
      () => accountId && rfpId && hotelsPerDestination,
      () => api.server.post(`rfps/hotel/booking-analytics/${accountId}/rfps/${rfpId}/create-bids`, {hotelsPerDestination})
    ),

    upload: (accountId, data) => checkAndExecute(
      () => accountId && data,
      () => api.server.post(`rfps/hotel/booking-analytics/${accountId}/upload`, data),
    ),

    getUploadStatus: (accountId, uploadId) => checkAndExecute(
      () => accountId && uploadId,
      () => api.server.get(`rfps/hotel/booking-analytics/${accountId}/upload/${uploadId}/status`),
    ),

    getUploadReport: accountId => checkAndExecute(
      () => accountId,
      () => api.server.get(`rfps/hotel/booking-analytics/${accountId}/upload-report`),
    ),

    createDestinationSuggestions: (accountId, rfpId, hotelIds) => checkAndExecute(
      () => accountId && rfpId && hotelIds && hotelIds.length,
      () => api.server.post(`rfps/hotel/booking-analytics/${accountId}/rfps/${rfpId}/destinations/suggest`, {hotelIds}),
    ),

    checkCreateDestinationSuggestionsProgress: (accountId, rfpId, jobId) => checkAndExecute(
      () => accountId && rfpId && jobId,
      () => api.server.get(`rfps/hotel/booking-analytics/${accountId}/rfps/${rfpId}/destinations/suggest/${jobId}/status`),
    ),

    createDestinations: (accountId, rfpId, travelDestinations) => checkAndExecute(
      () => accountId && rfpId && travelDestinations && travelDestinations.length,
      () => api.server.post(`rfps/hotel/booking-analytics/${accountId}/rfps/${rfpId}/destinations/create`, {travelDestinations}),
    ),

    exportAsCsv: (filename, headers, data) => checkAndExecute(
      () => filename && headers && data,
      () => api.server.asCsvFileDownload(filename, headers, data),
    ),

    export: (accountId, exportId, data, filename) => checkAndExecute(
      () => accountId && exportId,
      () => api.server.postAndAutoSaveFile(`rfps/hotel/booking-analytics/${accountId}/exports`, {id: exportId, filename, options: data}),
    )
  }
}
